import { Injectable } from '@angular/core';
import { UtilsService } from '../utils/utils.service';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class ManagerConfigurationsService {

  constructor(
    private _utilsService: UtilsService
  ) { }

  getManagerConfigurationsByQuery(query) {
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.getManagerConfig);
    return this._utilsService.getAPICall(url, this._utilsService.setHeaderWithParams(query));
  }

  updateManagerConfigurations(query, configObj) {
    query.manager_config = configObj;
    const url = this._utilsService.apiUrlGeneration(environment.webPrivateV1, environment.webPrivateV1.saveManagerConfig);
    return this._utilsService.postAPICall(url, query, this._utilsService.setHeaders());
  }
}
